module.exports = __webpack_public_path__ + "static/media/logo-branco.571ad13d.png";